var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('profile-info-edit', {
    attrs: {
      "onSave": _vm.updateProfile,
      "loading": _vm.isFetching,
      "profile": _vm.profile,
      "companyFullName": _vm.companyFullName,
      "orgTypes": _vm.orgTypes
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a0512e6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/profile/ProfileInfoEditContainer.vue
// module id = 939
// module chunks = 0